import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import TimeOffRequestBody from "./TimeOffRequestBody";

export default class TimeOffService {
  request = new TimeOffRequestBody();
  static shared = new TimeOffService();

  getTimeOffRequestsRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getTimeOffRequests(payload.page, payload.size, payload.employeeName, payload.sort, payload.status),
          this.request.getTimeOffRequestsRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  approveTimeOffRequestRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.approveTimeOffRequest(payload.id, payload.status),
          this.request.approveTimeOffRequestRequest(REQUEST_METHOD.PUT, { approvalRemarks: payload.approvalRemarks || "" })
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getTimeOffByIdRequest = (id) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getTimeOffById(id),
          this.request.getTimeOffByIdRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updateTimeOffRequestRequest = (id, payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.updateTimeOffRequest(id),
          this.request.updateTimeOffRequestRequest(REQUEST_METHOD.PUT, payload)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  createTimeOffRequestRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.createTimeOffRequest(payload.userId),
          this.request.createTimeOffRequestRequest(REQUEST_METHOD.POST, payload)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}
